"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopularBrands = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../../constants");
var _hooks = require("../../../hooks");
var _useTranslations = require("../../../hooks/useTranslations");
var _constants2 = require("../CategoryContent/constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ElementWithAnalytics = props => {
  const {
    url,
    title,
    id,
    index,
    Component
  } = props;
  const handleAnalytics = (0, _react.useCallback)(() => {
    const incrementedIndex = index + 1; // Indexes has to start from 1
    const withSegmentData = [..._constants.CLICK_CATEGORY_BRAND, url, title, incrementedIndex.toString()];
    UserAction.dispatch(withSegmentData);
  }, [title, url, index]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
    href: url,
    onClick: handleAnalytics,
    children: title
  }, id);
};
const PopularBrands = ({
  subCategory,
  activeSubCategory,
  handleSubCategoryClick
}) => {
  const isMobile = (0, _hooks.useIsMobile)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const ownerState = {
    isSubcategoryActive: activeSubCategory === subCategory.linkType
  };
  const popularBrandsClickHandler = (0, _react.useCallback)(() => {
    handleSubCategoryClick(subCategory.linkType);
  }, [handleSubCategoryClick, subCategory.linkType]);
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PopularBrandsRoot, {
      "data-testid": getTestId(_constants2.POPULAR_BRANDS_ROOT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PopularBrandsListElement, {
        disableRipple: true,
        "data-testid": getTestId(_constants2.POPULAR_BRANDS_LIST_ELEMENT),
        onClick: popularBrandsClickHandler,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsTitle, {
          as: _mui.Typography,
          children: translations.brands
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsIconWrapper, {
          ownerState: ownerState,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
            fontSize: "inherit"
          })
        })]
      }), activeSubCategory === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.PopularBrands && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [subCategory.children.map((segment, index) => segment.url && /*#__PURE__*/(0, _jsxRuntime.jsx)(ElementWithAnalytics, {
          Component: _styles.PopularBrandsSegment,
          url: segment.url,
          title: segment.title ?? '',
          id: segment.id ?? '',
          index: index
        }, segment.id)), subCategory.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsSegment, {
          href: subCategory.url,
          children: translations.allBrands
        }) : null]
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PopularBrandsRoot, {
    "data-testid": getTestId(_constants2.POPULAR_BRANDS_ROOT),
    children: [subCategory.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsListElement, {
      "data-testid": getTestId(_constants2.POPULAR_BRANDS_LIST_ELEMENT),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ElementWithAnalytics, {
        index: 1,
        id: subCategory.id,
        Component: _styles.PopularBrandsTitle,
        url: subCategory.url,
        title: translations.brands
      })
    }) : null, subCategory.children.map((segment, index) => segment.url && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsListElement, {
      "data-testid": getTestId(_constants2.POPULAR_BRANDS_LIST_ELEMENT),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ElementWithAnalytics, {
        Component: _styles.PopularBrandsSegment,
        url: segment.url,
        title: segment.title ?? '',
        id: segment.id ?? '',
        index: index
      })
    }, segment.id)), subCategory.url ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsListElement, {
      "data-testid": getTestId(_constants2.POPULAR_BRANDS_LIST_ELEMENT),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.PopularBrandsAllBrands, {
        href: subCategory.url,
        children: translations.allBrands
      })
    }) : null]
  });
};
exports.PopularBrands = PopularBrands;
